export const AIModels = Object.freeze({
    OPENAI: 'OpenAI',
    GEMINI: 'Gemini',
    ANTHROPIC: 'Anthropic',
});

export const AIModelVersions = Object.freeze({
    GEMINI: {
        'GEMINI_2_5_FLASH': 'gemini-2.5-flash',
        'GEMINI_2_5_PRO': 'gemini-2.5-pro-preview-06-05',
    },
    OPENAI: {
        'GPT-5.1': 'gpt-5.1',
        'GPT-5-mini': 'gpt-5-mini',
        'GPT-5.4-mini': 'gpt-5.4-mini',
        'GPT_4O': 'gpt-4o',
        'GPT_4O_MINI': 'gpt-4o-mini',
        'GPT_4O_TURBO': 'gpt-4-turbo',
    },
    ANTHROPIC: {
        'CLAUDE_SONNET_4_6': 'claude-sonnet-4-6',
        'CLAUDE_OPUS_4_6': 'claude-opus-4-6',
        'CLAUDE_HAIKU_4_5': 'claude-haiku-4-5-20251001',
    },
});

export const AIModelStatus = Object.freeze({
    ACTIVE: 'Active',
    INACTIVE: 'Inactive',
    //DISABLED: 'Disabled',
});

// Default values
export const DEFAULT_AI_MODEL = AIModels.OPENAI;
export const DEFAULT_AI_MODEL_VERSION = AIModelVersions.OPENAI.GPT_4O_MINI;
export const DEFAULT_AI_MODEL_STATUS = AIModelStatus.ACTIVE;
export const DEFAULT_AI_DYNAMIC_MODEL_VERSION = {
  [AIModels.OPENAI]:  AIModelVersions.OPENAI.GPT_4O_MINI,
  [AIModels.GEMINI]:  AIModelVersions.GEMINI.GEMINI_2_5_FLASH,
  [AIModels.ANTHROPIC]: AIModelVersions.ANTHROPIC.CLAUDE_SONNET_4_6,
};

// New provider catalog (kept in public enum too for compatibility with any path resolution quirks)
export const AI_PROVIDERS = Object.freeze({
  OPENAI: { key: 'openai', label: 'OpenAI', priority: 1, is_active: true },
  ANTHROPIC: { key: 'anthropic', label: 'Anthropic', priority: 2, is_active: true },
});

export const AI_MODEL_CATALOG = Object.freeze({
  openai: [
    { key: 'gpt-5.1', display_name: 'GPT-5.1', is_active: true },
    { key: 'gpt-5-mini', display_name: 'GPT-5 Mini', is_active: true },
    { key: 'gpt-5.4-mini', display_name: 'GPT-5.4 Mini', is_active: true },
  ],
  anthropic: [
    { key: 'claude-haiku-4-5-20251001', display_name: 'Claude Haiku 4.5', is_active: true },
    { key: 'claude-sonnet-4-6', display_name: 'Claude Sonnet 4.6', is_active: true },
    { key: 'claude-opus-4-6', display_name: 'Claude Opus 4.6', is_active: true },
  ],
});

export const AI_FEATURE_KEYS = Object.freeze({
  AUTOMATION_RECORDING: 'automation_recording',
  REPLAY_FLOW: 'replay_flow',
  TEST_LAUNCH: 'test_launch',
  AI_GENERATOR: 'ai_generator',
  SECURITY_GUARDRAILS: 'security_guardrails',
});

export function getModelDisplayName(provider, modelKey) {
  return (AI_MODEL_CATALOG[provider] || []).find(m => m.key === modelKey)?.display_name || modelKey;
}

export function getActiveProviders() {
  return Object.values(AI_PROVIDERS)
    .filter(p => p.is_active)
    .sort((a, b) => a.priority - b.priority);
}

export function getActiveModels(provider) {
  return (AI_MODEL_CATALOG[provider] || []).filter(m => m.is_active);
}
